import React from 'react';

export const ShieldIcon = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      viewBox='0 0 16 20'
      focusable='false'
      width={width}
      height={height}
      className='icon icon-shield'
      {...rest}
    >
      <path
        d='M11 1 3 4.556v5.333a11.062 11.062 0 0 0 8 10.667 11.062 11.062 0 0 0 8-10.667V4.556zM9.222 15.222l-3.555-3.555 1.253-1.254 2.3 2.293 5.86-5.857 1.253 1.262z'
        transform='translate(-3 -1)'
        fill={fill}
      />
    </svg>
  );
};

ShieldIcon.defaultProps = {
  width: 16,
  height: 20,
  fill: 'var(--pale-grey)'
};
